function formatCnjFromDigits(digits) {
  if (digits.length !== 20) return null;

  return `${digits.slice(0, 7)}-${digits.slice(7, 9)}.${digits.slice(9, 13)}.${digits.slice(13, 14)}.${digits.slice(14, 16)}.${digits.slice(16, 20)}`;
}

/**
 * Interpreta CNJ com sufixo de incidente (padrão TJSP: .../02, .../0003).
 */
export function parseCnjProcessNumber(input) {
  if (!input) return null;

  const raw = String(input).trim();
  if (!raw) return null;

  const cleaned = raw.replace(/[\*\.]+$/g, "").trim();
  const slashIndex = cleaned.indexOf("/");

  let incidentDigits = null;
  let mainPart = cleaned;

  if (slashIndex >= 0) {
    mainPart = cleaned.slice(0, slashIndex).trim();
    const incidentRaw = cleaned.slice(slashIndex + 1).replace(/\D/g, "");
    incidentDigits = incidentRaw || null;
  }

  const baseDigits = mainPart.replace(/\D/g, "");
  if (baseDigits.length !== 20) return null;

  const formattedBase = formatCnjFromDigits(baseDigits);
  const formattedWithIncident = incidentDigits
    ? `${formattedBase}/${incidentDigits}`
    : null;

  return {
    raw,
    baseDigits,
    incidentDigits,
    formattedBase,
    formattedWithIncident,
    hasIncident: Boolean(incidentDigits),
  };
}

export function formatProcessNumberWithIncident(processNumber) {
  if (!processNumber) return "";

  const parsed = parseCnjProcessNumber(processNumber);
  if (parsed) {
    return parsed.formattedWithIncident ?? parsed.formattedBase;
  }

  const digits = String(processNumber).replace(/\D/g, "");
  if (digits.length === 20) {
    return formatCnjFromDigits(digits);
  }

  return processNumber;
}

export function normalizeCnjBaseDigits(processNumber) {
  const parsed = parseCnjProcessNumber(processNumber);
  if (parsed) return parsed.baseDigits;

  const digits = String(processNumber || "").replace(/\D/g, "");
  return digits.length > 0 ? digits : "";
}
